import * as React from 'react';

export interface DeleteIconProps {
  size: number;
}

export const DeleteIcon: React.FunctionComponent<DeleteIconProps> = ({ size }) => {
  return (
    <svg width={size} height={size + 2} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 5L11.8944 2.78885C11.3463 1.69253 10.2257 1 9 1C7.77427 1 6.65374 1.69253 6.10557 2.78885L5 5M1 5H17M3 5H15V13C15 14.8638 15 15.7957 14.6955 16.5307C14.2895 17.5108 13.5108 18.2895 12.5307 18.6955C11.7956 19 10.8638 19 9 19C7.13623 19 6.20435 19 5.46927 18.6955C4.48915 18.2895 3.71046 17.5108 3.30448 16.5307C3 15.7957 3 14.8638 3 13V5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
